import { LIVE_MATHS_STUDENT_RETRIEVED } from './student-actions';

const initialState = null;

/**
 * Live Maths - Student Reducer
 *
 * Consumes LIVE_MATHS_STUDENT_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case LIVE_MATHS_STUDENT_RETRIEVED:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/live-maths/student/student-reducer.js